var map = {
	"./App.tsx": "./src/v2/App.tsx",
	"./admin/AddParamForm.tsx": "./src/v2/admin/AddParamForm.tsx",
	"./admin/AdminApi.tsx": "./src/v2/admin/AdminApi.tsx",
	"./admin/AdminBadge.tsx": "./src/v2/admin/AdminBadge.tsx",
	"./admin/AdminContext.tsx": "./src/v2/admin/AdminContext.tsx",
	"./admin/AdminModeToggle.tsx": "./src/v2/admin/AdminModeToggle.tsx",
	"./admin/AdminPanel.tsx": "./src/v2/admin/AdminPanel.tsx",
	"./admin/CodeEditor.tsx": "./src/v2/admin/CodeEditor.tsx",
	"./admin/CreateProductForm.tsx": "./src/v2/admin/CreateProductForm.tsx",
	"./admin/DescriptorEditorDialog.tsx": "./src/v2/admin/DescriptorEditorDialog.tsx",
	"./admin/DxfExportButton.tsx": "./src/v2/admin/DxfExportButton.tsx",
	"./admin/JsonEditor.tsx": "./src/v2/admin/JsonEditor.tsx",
	"./admin/MarginInput.tsx": "./src/v2/admin/MarginInput.tsx",
	"./admin/NewCartButton.tsx": "./src/v2/admin/NewCartButton.tsx",
	"./admin/QuoteDescriptionEditor.tsx": "./src/v2/admin/QuoteDescriptionEditor.tsx",
	"./admin/QuoteTab.tsx": "./src/v2/admin/QuoteTab.tsx",
	"./admin/ScriptDiffDialog.tsx": "./src/v2/admin/ScriptDiffDialog.tsx",
	"./admin/ScriptsEditor.tsx": "./src/v2/admin/ScriptsEditor.tsx",
	"./admin/ScriptsTab.tsx": "./src/v2/admin/ScriptsTab.tsx",
	"./admin/StyleParamsEditor.tsx": "./src/v2/admin/StyleParamsEditor.tsx",
	"./admin/ViewOptionsTab.tsx": "./src/v2/admin/ViewOptionsTab.tsx",
	"./aiDesigner/AiDesignerContext.tsx": "./src/v2/aiDesigner/AiDesignerContext.tsx",
	"./aiDesigner/AiDesignerPanel.tsx": "./src/v2/aiDesigner/AiDesignerPanel.tsx",
	"./aiDesigner/AiDesignerTab.tsx": "./src/v2/aiDesigner/AiDesignerTab.tsx",
	"./aiDesigner/Markdown.tsx": "./src/v2/aiDesigner/Markdown.tsx",
	"./aiDesigner/ScriptsTab.tsx": "./src/v2/aiDesigner/ScriptsTab.tsx",
	"./cart/CartHandler.tsx": "./src/v2/cart/CartHandler.tsx",
	"./cart/CartItem.tsx": "./src/v2/cart/CartItem.tsx",
	"./cart/QuoteErrorDialog.tsx": "./src/v2/cart/QuoteErrorDialog.tsx",
	"./catalog/Catalog.tsx": "./src/v2/catalog/Catalog.tsx",
	"./catalog/CatalogHandler.tsx": "./src/v2/catalog/CatalogHandler.tsx",
	"./catalog/ICatalogItem.tsx": "./src/v2/catalog/ICatalogItem.tsx",
	"./common/DimensionUtils.tsx": "./src/v2/common/DimensionUtils.tsx",
	"./common/Fetcher.tsx": "./src/v2/common/Fetcher.tsx",
	"./common/PrestaGlobals.tsx": "./src/v2/common/PrestaGlobals.tsx",
	"./common/QuoteMarkdown.tsx": "./src/v2/common/QuoteMarkdown.tsx",
	"./common/ShownDesign.tsx": "./src/v2/common/ShownDesign.tsx",
	"./common/inputs/BoardDecorSelectorInput.tsx": "./src/v2/common/inputs/BoardDecorSelectorInput.tsx",
	"./common/inputs/DecorComboboxBase.tsx": "./src/v2/common/inputs/DecorComboboxBase.tsx",
	"./common/inputs/DecorSelectorInput.tsx": "./src/v2/common/inputs/DecorSelectorInput.tsx",
	"./common/inputs/EdgeDecorSelectorInput.tsx": "./src/v2/common/inputs/EdgeDecorSelectorInput.tsx",
	"./common/inputs/EnumSelectorInput.tsx": "./src/v2/common/inputs/EnumSelectorInput.tsx",
	"./common/inputs/NumericInput.tsx": "./src/v2/common/inputs/NumericInput.tsx",
	"./common/inputs/TextFieldInput.tsx": "./src/v2/common/inputs/TextFieldInput.tsx",
	"./common/inputs/ToggleField.tsx": "./src/v2/common/inputs/ToggleField.tsx",
	"./common/inputs/UnitField.tsx": "./src/v2/common/inputs/UnitField.tsx",
	"./common/inputs/ValueReset.tsx": "./src/v2/common/inputs/ValueReset.tsx",
	"./configurator/AddToCartContainer.tsx": "./src/v2/configurator/AddToCartContainer.tsx",
	"./configurator/Configurator.tsx": "./src/v2/configurator/Configurator.tsx",
	"./configurator/cards/BackPassingCardContent.tsx": "./src/v2/configurator/cards/BackPassingCardContent.tsx",
	"./configurator/cards/BoardContent.tsx": "./src/v2/configurator/cards/BoardContent.tsx",
	"./configurator/cards/BoardDecorCardContent.tsx": "./src/v2/configurator/cards/BoardDecorCardContent.tsx",
	"./configurator/cards/BoolCardContent.tsx": "./src/v2/configurator/cards/BoolCardContent.tsx",
	"./configurator/cards/CountCardContent.tsx": "./src/v2/configurator/cards/CountCardContent.tsx",
	"./configurator/cards/DecorCardContent.tsx": "./src/v2/configurator/cards/DecorCardContent.tsx",
	"./configurator/cards/DrawerSystemCardContent.tsx": "./src/v2/configurator/cards/DrawerSystemCardContent.tsx",
	"./configurator/cards/EdgeContent.tsx": "./src/v2/configurator/cards/EdgeContent.tsx",
	"./configurator/cards/EdgeListContent.tsx": "./src/v2/configurator/cards/EdgeListContent.tsx",
	"./configurator/cards/EnumCardContent.tsx": "./src/v2/configurator/cards/EnumCardContent.tsx",
	"./configurator/cards/HardwareCardContent.tsx": "./src/v2/configurator/cards/HardwareCardContent.tsx",
	"./configurator/cards/ItemsCardContent.tsx": "./src/v2/configurator/cards/ItemsCardContent.tsx",
	"./configurator/cards/PanelContainerCard.tsx": "./src/v2/configurator/cards/PanelContainerCard.tsx",
	"./configurator/cards/PropertyContainerCard.tsx": "./src/v2/configurator/cards/PropertyContainerCard.tsx",
	"./configurator/cards/RailingCardContent.tsx": "./src/v2/configurator/cards/RailingCardContent.tsx",
	"./configurator/cards/SizeCardContent.tsx": "./src/v2/configurator/cards/SizeCardContent.tsx",
	"./configurator/cards/TextCardContent.tsx": "./src/v2/configurator/cards/TextCardContent.tsx",
	"./configurator/common/EdgeBorderedAvatar.tsx": "./src/v2/configurator/common/EdgeBorderedAvatar.tsx",
	"./database/Boards.tsx": "./src/v2/database/Boards.tsx",
	"./database/DatabaseHandler.tsx": "./src/v2/database/DatabaseHandler.tsx",
	"./database/Edges.tsx": "./src/v2/database/Edges.tsx",
	"./database/interfaces/IBoardData.tsx": "./src/v2/database/interfaces/IBoardData.tsx",
	"./database/interfaces/IDrawerSystem.tsx": "./src/v2/database/interfaces/IDrawerSystem.tsx",
	"./database/interfaces/IEdgeData.tsx": "./src/v2/database/interfaces/IEdgeData.tsx",
	"./database/interfaces/IHardware.tsx": "./src/v2/database/interfaces/IHardware.tsx",
	"./database/interfaces/paramScript/IBoardTypeDescriptor.tsx": "./src/v2/database/interfaces/paramScript/IBoardTypeDescriptor.tsx",
	"./database/interfaces/paramScript/ICountConfigTypeDescriptor.tsx": "./src/v2/database/interfaces/paramScript/ICountConfigTypeDescriptor.tsx",
	"./database/interfaces/paramScript/IDimensionsTypeDescriptor.tsx": "./src/v2/database/interfaces/paramScript/IDimensionsTypeDescriptor.tsx",
	"./database/interfaces/paramScript/IEdgeTypeDescriptor.tsx": "./src/v2/database/interfaces/paramScript/IEdgeTypeDescriptor.tsx",
	"./database/interfaces/paramScript/IFiltersDescriptor.tsx": "./src/v2/database/interfaces/paramScript/IFiltersDescriptor.tsx",
	"./database/interfaces/paramScript/IParamScript.tsx": "./src/v2/database/interfaces/paramScript/IParamScript.tsx",
	"./database/interfaces/paramScript/IParamTypeDescriptor.tsx": "./src/v2/database/interfaces/paramScript/IParamTypeDescriptor.tsx",
	"./database/interfaces/paramScript/IUnitsTypeDescriptor.tsx": "./src/v2/database/interfaces/paramScript/IUnitsTypeDescriptor.tsx",
	"./layout/LayoutHandler.tsx": "./src/v2/layout/LayoutHandler.tsx",
	"./layout/MainScreen.tsx": "./src/v2/layout/MainScreen.tsx",
	"./layout/UCThemeProvider.tsx": "./src/v2/layout/UCThemeProvider.tsx",
	"./layout/UnifiedLayout.tsx": "./src/v2/layout/UnifiedLayout.tsx",
	"./layout/common/EdgingIcon.tsx": "./src/v2/layout/common/EdgingIcon.tsx",
	"./layout/common/InstantCatalog.tsx": "./src/v2/layout/common/InstantCatalog.tsx",
	"./layout/common/SideMenuIconButton.tsx": "./src/v2/layout/common/SideMenuIconButton.tsx",
	"./layout/unified/DesktopInstacartTableRow.tsx": "./src/v2/layout/unified/DesktopInstacartTableRow.tsx",
	"./layout/unified/InterestSheet.tsx": "./src/v2/layout/unified/InterestSheet.tsx",
	"./layout/unified/InterestSteps.tsx": "./src/v2/layout/unified/InterestSteps.tsx",
	"./layout/unified/QuoteBar.tsx": "./src/v2/layout/unified/QuoteBar.tsx",
	"./layout/unified/QuoteDescriptionDialog.tsx": "./src/v2/layout/unified/QuoteDescriptionDialog.tsx",
	"./layout/unified/UnifiedInstacartContent.tsx": "./src/v2/layout/unified/UnifiedInstacartContent.tsx",
	"./layout/unified/UnifiedInstacartHeader.tsx": "./src/v2/layout/unified/UnifiedInstacartHeader.tsx",
	"./parametersProcessor/ParametersProcessor.tsx": "./src/v2/parametersProcessor/ParametersProcessor.tsx",
	"./parametersProcessor/TParameters.tsx": "./src/v2/parametersProcessor/TParameters.tsx",
	"./prefs/PrefsApi.tsx": "./src/v2/prefs/PrefsApi.tsx",
	"./unityView/UnityProgressBar.tsx": "./src/v2/unityView/UnityProgressBar.tsx",
	"./unityView/UnityView.tsx": "./src/v2/unityView/UnityView.tsx",
	"./unityView/UnityWarningLayer.tsx": "./src/v2/unityView/UnityWarningLayer.tsx",
	"./unityView/VisibilityMenu.tsx": "./src/v2/unityView/VisibilityMenu.tsx",
	"./unityView/interfaces/ICabinetResult.tsx": "./src/v2/unityView/interfaces/ICabinetResult.tsx",
	"./unityView/interfaces/IOrder.tsx": "./src/v2/unityView/interfaces/IOrder.tsx",
	"./unityView/interfaces/IShopInfo.tsx": "./src/v2/unityView/interfaces/IShopInfo.tsx",
	"./unityView/interfaces/UCWindow.tsx": "./src/v2/unityView/interfaces/UCWindow.tsx",
	"./unityView/transport/UnityEditorStatusPanel.tsx": "./src/v2/unityView/transport/UnityEditorStatusPanel.tsx",
	"./unityView/types/UnityConfig.tsx": "./src/v2/unityView/types/UnityConfig.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/v2 sync recursive \\.tsx$";